import { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { sponsorAxiosInstance } from '../base-service';
import { Tokens } from '@okta/okta-auth-js';

const OKTA_PATH = 'v1/sponsor/login/Okta';

const onRequest = (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
  let token: string | undefined | null;
  if (config.url === OKTA_PATH) {
    token = (JSON.parse(sessionStorage.getItem('nike.nde.passplayclient') ?? '{}') as Tokens)
      .accessToken?.accessToken;
  } else {
    token = sessionStorage.getItem('passplay-token');
  }
  config.headers['Authorization'] = `bearer ${token}`;
  return config;
};

const onRequestError = (error: AxiosError): Promise<AxiosError> => {
  return Promise.reject(error);
};

const registerReqInterceptors = () => {
  sponsorAxiosInstance.interceptors.request.use(onRequest, onRequestError);
};

export { registerReqInterceptors };
